var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1632 30.2227L64.9079 25.4946M60.1632 30.2227H45.1194M60.1632 30.2227V37.6032V37.9491V42.3313M64.9079 25.4946V37.6032L60.1632 42.3313M64.9079 25.4946H49.8639M45.1194 30.2227L49.8639 25.4946M45.1194 30.2227V9.46527M60.1632 42.3313H55.8815M60.1632 42.3313V47.0593V90.9962L55.8815 95.2628H55.6501M60.1632 42.3313L55.6501 47.0593M45.1194 37.6032C45.1194 37.6032 48.0111 37.6032 49.8639 37.6032M45.1194 37.6032V39.9672M45.1194 37.6032H49.8639M49.8639 37.6032C52.2139 37.6032 55.8815 37.6032 55.8815 37.6032M49.8639 37.6032H55.8815M49.8639 37.6032C48.0111 39.4496 46.9723 40.4848 45.1194 42.3313M49.8639 37.6032L45.1194 42.3313M45.1194 39.9672C45.1194 39.9672 45.1194 41.408 45.1194 42.3313M45.1194 39.9672V42.3313M55.8815 37.6032V42.3313M55.8815 42.3313L51.1369 47.0593M51.1369 47.0593V59.6291M51.1369 47.0593H55.6501M55.6501 95.2628H51.1369V74.8515H35.6301V47.0593M55.6501 95.2628V47.0593M49.8639 25.4946V4.73718M45.1194 9.46527L49.8639 4.73718M45.1194 9.46527H40.3747M49.8639 4.73718H47.4916H45.1194L40.3747 9.46527M40.3747 9.46527V42.3313M40.3747 42.3313C40.3747 42.3313 43.2664 42.3313 45.1194 42.3313M40.3747 42.3313H40.259C40.259 42.3313 43.2212 42.3313 45.1194 42.3313M40.3747 42.3313H45.1194M40.3747 42.3313L38.0024 44.6953L35.6301 47.0593M45.1194 42.3313L42.7471 44.6953L40.3747 47.0593M45.1194 42.3313V50.9802V59.6291M35.6301 47.0593H40.3747M40.3747 47.0593V64.2419H40.4905M45.1194 59.6291L40.4905 64.2419M45.1194 59.6291H51.1369M40.4905 64.2419H51.1369V59.6291",
    stroke: "url(#paint0_linear_201_1826)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_1826",
    x1: 50.269,
    y1: 4.73718,
    x2: 50.269,
    y2: 95.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB4839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5CD22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35AFA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoActive);
export default __webpack_public_path__ + "static/media/logoActive.a9273db13fb4bbaa52484d9eadd2a51f.svg";
export { ForwardRef as ReactComponent };